










































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { auctionModule, snackModule, authModule } from '@/store';
import { Auction, Lot } from '@/api';
import SingleLot from '@/components/frontend/SingleLot.vue';
import BidDialog from '@/components/frontend/BidDialog.vue';
import moment from 'moment';

@Component({
  components: { SingleLot, BidDialog },
})
export default class extends Vue {
  loadingAuction: boolean = false;
  loadingLots: boolean = false;
  loadingPrint: boolean = false;

  view: string = 'grid';

  auction: Auction | null = null;
  imageLots: Lot[] | null = null;
  regularLots: Lot[] | null = null;
  lots: Lot[] = [];
  allLots: Lot[] = [];

  lotDialog: boolean = false;
  bidDialog: boolean = false;
  selectedLot: Lot | null = null;
  selectedLotIndex: number | null = null;
  showLotArrows: boolean = true;

  search: string = '';
  page: number = 1;
  imagePageLen: number = 1;
  regularPageLen: number = 1;
  pageLen: number = 1;
  pageStop: boolean = false;
  lotsPerPage: number = 80;
  imageCurrentPage: number = 1;
  regularCurrentPage: number = 1;
  jumpNumber: string = '';
  lotSnack: boolean = false;

  querySetup: boolean = true;

  showLot(lot: Lot) {
    if (!this.lots.length || !lot) {
      return false;
    }
    this.selectedLot = lot;
    this.selectedLotIndex = this.lots.indexOf(lot);
    this.showLotArrows = true;
    this.lotDialog = true;
    this.queryChange();
  }

  prevLot() {
    if (this.selectedLotIndex == null || !this.lots.length) {
      return false;
    }
    this.selectedLot = this.lots[this.selectedLotIndex - 1];
    this.selectedLotIndex = this.selectedLotIndex - 1;
  }

  nextLot() {
    if (this.selectedLotIndex == null || !this.lots.length) {
      return false;
    }
    this.selectedLot = this.lots[this.selectedLotIndex + 1];
    this.selectedLotIndex = this.selectedLotIndex + 1;
  }

  lotClosed() {
    this.lotDialog = false;
  }

  get auctionId() {
    return this.$route.params.auctionId;
  }

  get searchQuery() {
    return this.$route.query.search;
  }

  get viewQuery() {
    return this.$route.query.view;
  }

  get lotQuery() {
    return this.$route.query.lot;
  }

  get pageQuery() {
    return this.$route.query.page;
  }

  get auctionDate() {
    if (!this.auction) {
      return;
    }
    return moment(this.auction.date).format('D MMMM YYYY');
  }

  doSearch() {
    this.queryChange(true);
    this.doQuery();
  }

  scrollToLot(lot: Lot) {
    const lotIndex = this.lots.indexOf(lot);
    const lotItems = document.querySelectorAll('.lot');
    const offset = innerWidth > 599 ? 200 : 70;

    if (lotItems[lotIndex]) {
      window.scrollTo({
        top: (lotItems[lotIndex] as HTMLElement).offsetTop - offset,
        behavior: 'smooth',
      });
    }
  }

  async jumpToLot() {
    this.jumpNumber = this.jumpNumber.trim();

    if (!this.jumpNumber || this.loadingLots) {
      return;
    }

    const existingLot = this.lots.find(item => item.number === this.jumpNumber);

    if (existingLot) {
      this.scrollToLot(existingLot);
    } else {
      try {
        this.loadingLots = true;

        let scope = Lot.extraParams({
          page: { lot_number: this.jumpNumber, size: this.lotsPerPage },
        })
          .order('ordering')
          .where({ auction: this.auctionId, search: this.search })
          .includes(['auction']);

        if (this.view === 'images') {
          scope = scope.where({ has_images: true });
        }
        const query = await scope.all();
        this.lots = query.data;

        this.pageStop = true;
        this.page = query.meta.pagination.page;
      } catch (error) {
        // Error
        this.lotSnack = true;
      } finally {
        this.loadingLots = false;

        setTimeout(() => {
          const newLot = this.lots.find(
            item => item.number === this.jumpNumber,
          );

          if (newLot) {
            this.scrollToLot(newLot);
          }
        }, 200);
      }
    }
  }

  async doQuery() {
    if (this.querySetup) {
      if (this.pageQuery && typeof this.pageQuery === 'string') {
        this.page = parseInt(this.pageQuery, 10);
      }
      this.querySetup = false;
    }

    try {
      this.loadingLots = true;

      if (this.view === 'images') {
        const imageScope = Lot.per(this.lotsPerPage)
          .page(this.page)
          .order('ordering')
          .where({
            auction: this.auctionId,
            search: this.search,
            has_images: true,
          })
          .includes(['auction']);
        const imageQuery = await imageScope.all();
        this.imageLots = imageQuery.data;
        this.imagePageLen = imageQuery.meta.pagination.pages;

        this.lots = this.imageLots;
        this.pageLen = this.imagePageLen;
      } else {
        const regularScope = Lot.per(this.lotsPerPage)
          .page(this.page)
          .order('ordering')
          .where({ auction: this.auctionId, search: this.search })
          .includes(['auction']);
        const regularQuery = await regularScope.all();
        this.regularLots = regularQuery.data;
        this.regularPageLen = regularQuery.meta.pagination.pages;

        this.lots = this.regularLots;
        this.pageLen = this.regularPageLen;
      }
    } catch (err) {
      // Error
      this.$router.push({
        name: 'not-found',
        params: { '0': this.$route.fullPath },
      });
    } finally {
      this.loadingLots = false;
    }
  }

  queryChange(stopRecursion: boolean = false) {
    const search = this.searchQuery || '';
    const view = this.viewQuery || null;
    const lot = this.lotQuery || '';
    const selectedLot = this.selectedLot ? this.selectedLot.id : '';

    if (
      !stopRecursion ||
      (stopRecursion && search !== this.search) ||
      (stopRecursion && view !== this.view) ||
      (stopRecursion && lot !== selectedLot)
    ) {
      const q: {
        search?: string;
        page?: string;
        view?: string;
        lot?: string;
      } = {};

      if (this.search.trim() !== '') {
        q.search = this.search;
      }

      if (selectedLot) {
        q.lot = selectedLot;
      }

      if (this.view !== view && view) {
        if (this.page > 1) {
          this.page = 1;
          this.pageStop = true;
        }
      } else if (
        (!this.searchQuery && !this.search) ||
        (this.searchQuery === this.search && this.page > 1)
      ) {
        q.page = this.page.toString();
      } else {
        if (this.page > 1) {
          this.page = 1;
          this.pageStop = true;
        }
      }

      q.view = this.view;

      this.jumpNumber = '';

      this.$router.push({
        ...this.$route,
        query: q,
      });
    }
  }

  setView(view: string) {
    if (!view || this.view === view) {
      return;
    }

    this.view = view;

    this.queryChange(true);
    this.doQuery();

    authModule.trackEvent({
      gtag: this.$gtag,
      eventAction: 'set_view',
      eventCategory: 'engagement',
      eventLabel: view,
    });
  }

  get isCurrent() {
    if (!this.auction) {
      return;
    }

    return (
      this.auction.status === 'current' &&
      (!this.auction.bidsCloseAt ||
        this.auction.bidsCloseAt >= new Date().toISOString())
    );
  }

  hasBid(lot: Lot) {
    if (!authModule.user || !lot || !lot.id || !lot.auction.id) {
      return false;
    }
    const bid = auctionModule.bids[lot.auction.id][lot.id];
    if (bid) {
      return true;
    } else {
      return false;
    }
  }

  currentBid(lot: Lot) {
    if (!authModule.user || !lot || !lot.id || !lot.auction.id) {
      return false;
    }

    const bid = auctionModule.bids[lot.auction.id][lot.id];
    if (bid) {
      const value = bid.value / 100;
      return this.formatCurrency(value);
    }
  }

  tryBid(lot: Lot) {
    if (!lot) {
      return;
    }
    this.selectedLot = lot;

    if (!authModule.isLoggedIn) {
      authModule.openLoginDialog(this.doBid);
    } else {
      this.doBid();
    }
  }

  lotPrice(price: number) {
    if (!price) {
      return;
    }

    const value = price / 100;
    return this.formatCurrency(value);
  }

  formatCurrency(value: number) {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
      minimumFractionDigits: 0,
    }).format(value);
  }

  doBid() {
    this.bidDialog = true;
  }

  tryWishlist(lot: Lot) {
    if (!lot) {
      return;
    }
    this.selectedLot = lot;

    if (!authModule.isLoggedIn) {
      authModule.openLoginDialog(null);
    } else {
      this.toggleWish();
    }
  }

  wishIcon(lot: Lot) {
    if (!authModule.user || !lot.id || !lot.auction.id) {
      return false;
    }
    const wish = auctionModule.wishes[lot.auction.id][lot.id];
    if (wish) {
      return true;
    } else {
      return false;
    }
  }

  async toggleWish() {
    if (
      !this.selectedLot ||
      !this.selectedLot.id ||
      !this.selectedLot.auction.id
    ) {
      return;
    }
    try {
      const wish =
        auctionModule.wishes[this.selectedLot.auction.id][this.selectedLot.id];
      if (wish) {
        await auctionModule.removeWish(this.selectedLot);
      } else {
        await auctionModule.addWish(this.selectedLot);
        authModule.trackEvent({
          gtag: this.$gtag,
          eventAction: 'add_to_wishlist',
          eventCategory: 'engagement',
          eventLabel: this.selectedLot.title,
        });
      }
    } catch (e) {
      // Error
    }
  }

  async print(currentPage: number = 1) {
    try {
      this.loadingPrint = true;
      const scope = Lot.order('ordering')
        .per(100)
        .page(currentPage)
        .where({
          auction: this.auctionId,
          search: this.searchQuery,
        });
      const r = await scope.all();
      const maxPages = r.meta.pagination.pages;
      if (currentPage === 1) {
        this.allLots = r.data;
      } else {
        this.allLots = this.allLots.concat(r.data);
      }

      if (currentPage >= maxPages) {
        setTimeout(() => {
          this.loadingPrint = false;
          window.print();
        }, 200);
      } else {
        this.print(currentPage + 1);
      }
    } catch (e) {
      // Error
    }
  }

  doPrint() {
    this.print();
  }

  printEvent(e: KeyboardEvent) {
    if (
      (e.ctrlKey || e.metaKey) &&
      (e.key === 'p' ||
        e.charCode === 16 ||
        e.charCode === 112 ||
        e.keyCode === 80)
    ) {
      e.cancelBubble = true;
      e.preventDefault();
      e.stopImmediatePropagation();

      this.print();
    }
  }

  async mounted() {
    window.addEventListener('keydown', this.printEvent);

    try {
      this.loadingAuction = true;
      this.auction = (await Auction.find(this.auctionId)).data;
      if (this.auction.title) {
        document.title = this.auction.title + ' - Gowans Auctions';

        authModule.trackPageview({
          gtag: this.$gtag,
          route: this.$route,
          pageTitle: this.auction.title,
        });
      }
      auctionModule.checkAuctionWishes(this.auctionId);
      auctionModule.checkAuctionBids(this.auctionId);
    } catch (err) {
      // Not found
      document.title = 'Gowans Auctions';
    } finally {
      this.loadingAuction = false;

      if (this.searchQuery && typeof this.searchQuery === 'string') {
        this.search = this.searchQuery;
      }
      if (this.viewQuery && typeof this.viewQuery === 'string') {
        this.view = this.viewQuery;
      }
      if (this.lotQuery && typeof this.lotQuery === 'string') {
        try {
          const lot = (await Lot.includes(['auction']).find(this.lotQuery))
            .data;
          this.selectedLot = lot;
          this.lotDialog = true;
          this.showLotArrows = false;
        } catch (err) {
          // Not found
        }
      }

      this.doQuery();
    }
  }

  beforeDestroy() {
    window.removeEventListener('keydown', this.printEvent);
  }

  @Watch('page')
  pageChanged() {
    if (!this.pageStop) {
      this.queryChange();
      this.doQuery();
    } else {
      this.pageStop = false;
    }
  }

  @Watch('lotDialog')
  dialogClosed() {
    if (this.lotDialog === false) {
      this.selectedLot = null;
      this.queryChange(true);
    }
  }

  @Watch('$route.query')
  async queryChanged() {
    if (
      (this.searchQuery || '') !== this.search &&
      (typeof this.searchQuery === 'string' ||
        typeof this.searchQuery === 'undefined')
    ) {
      this.search = this.searchQuery || '';

      this.doQuery();
    }

    if (this.viewQuery !== this.view && typeof this.viewQuery === 'string') {
      this.setView(this.viewQuery);
    }

    const lotID = this.selectedLot ? this.selectedLot.id : '';
    if (
      this.lotQuery !== lotID &&
      (typeof this.lotQuery === 'string' ||
        typeof this.lotQuery === 'undefined')
    ) {
      if (this.lotQuery) {
        try {
          const lot = (await Lot.includes(['auction']).find(this.lotQuery))
            .data;
          this.selectedLot = lot;
          this.lotDialog = true;
          this.showLotArrows = false;
        } catch (err) {
          // Not found
        }
      } else {
        this.lotDialog = false;
      }
    }
  }
}
